import React, { useEffect, useState } from "react";
import "../../../assets/css/admin/AdminCommon.css";
import "../../../assets/css/admin/account/Account.css";
import flowerIcon from "../../../assets/img/flower_icon.png";
import lockIcon from "../../../assets/img/lockIcon.svg";
import { changeMyPassword, getMyAccount } from "../../../api/accountApi";
import { getStoredAdminInfo } from "../AdminAuth";

export default function Account() {
  const { isAudit, isCc, isStdCouncil, unitName } = getStoredAdminInfo();

  const [accountInfo, setAccountInfo] = useState({
    loginId: "",
    userName: "",
    roleDisplay: "",
  });

  const [currentPw, setCurrentPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const isCcAccount = isCc || isAudit;

  const getRoleDisplay = (serverRoleDisplay) => {
    if (isAudit) return "감사위원회";
    if (isCc) return `${unitName} 관리자`;
    if (isStdCouncil) return "총학생회 관리자";

    return serverRoleDisplay || "-";
  };

  useEffect(() => {
    const fetchAccountInfo = async () => {
      try {
        setIsLoading(true);

        const result = await getMyAccount();

        setAccountInfo({
          loginId: result?.loginId || "",
          userName: result?.userName || "",
          roleDisplay: getRoleDisplay(result?.roleDisplay),
        });
      } catch (error) {
        console.error("계정 정보 조회 실패:", error);
        alert(error.message || "계정 정보 조회에 실패했습니다.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchAccountInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (!currentPw || !newPw || !confirmPw) {
      alert("비밀번호를 모두 입력해 주세요.");
      return;
    }

    if (newPw !== confirmPw) {
      alert("새 비밀번호가 일치하지 않습니다.");
      return;
    }

    try {
      setIsSaving(true);

      await changeMyPassword({
        currentPassword: currentPw,
        newPassword: newPw,
        confirmPassword: confirmPw,
      });

      alert("비밀번호가 변경되었습니다.");

      setCurrentPw("");
      setNewPw("");
      setConfirmPw("");
    } catch (error) {
      console.error("비밀번호 변경 실패:", error);
      alert(error.message || "비밀번호 변경에 실패했습니다.");
    } finally {
      setIsSaving(false);
    }
  };

  const accountContent = (
    <>
      <section className="account-section">
        <h2 className="section-title">계정 정보</h2>

        <div className="info-row">
          <span className="label">아이디</span>
          <span className="value">
            {isLoading ? "불러오는 중..." : accountInfo.loginId || "-"}
          </span>

          <span className="label">이름</span>
          <span className="value">
            {isLoading ? "불러오는 중..." : accountInfo.userName || "-"}
          </span>

          <span className="label">권한 그룹</span>
          <span className="value">
            {isLoading ? "불러오는 중..." : accountInfo.roleDisplay || "-"}
          </span>
        </div>
      </section>

      <section className="account-section">
        <h2 className="section-title">비밀번호 변경</h2>

        <form onSubmit={handlePasswordChange} className="password-form">
          <div className="password-row">
            <label className="password-label">
              <img src={flowerIcon} alt="" />
              현재 비밀번호
            </label>

            <div className="password-input-wrap">
              <input
                type="password"
                placeholder="현재 비밀번호"
                value={currentPw}
                onChange={(e) => setCurrentPw(e.target.value)}
                className="current-password-input"
                disabled={isSaving}
              />
            </div>
          </div>

          <div className="password-row">
            <label className="password-label">
              <img src={flowerIcon} alt="" />
              새 비밀번호
            </label>

            <div className="password-input-wrap">
              <input
                type="password"
                placeholder="새 비밀번호를 입력해 주세요."
                value={newPw}
                onChange={(e) => setNewPw(e.target.value)}
                disabled={isSaving}
              />
              <img src={lockIcon} className="password-lock-icon" alt="" />
            </div>
          </div>

          <div className="password-row">
            <label className="password-label">
              <img src={flowerIcon} alt="" />
              새 비밀번호 확인
            </label>

            <div className="password-input-wrap">
              <input
                type="password"
                placeholder="새 비밀번호를 재확인해 주세요."
                value={confirmPw}
                onChange={(e) => setConfirmPw(e.target.value)}
                disabled={isSaving}
              />
              <img src={lockIcon} className="password-lock-icon" alt="" />
            </div>
          </div>

          <button type="submit" className="change-btn" disabled={isSaving}>
            {isSaving ? "저장 중..." : "저장"}
          </button>
        </form>
      </section>
    </>
  );

  return (
    <div className={`account-page ${isCcAccount ? "cc-account-page" : ""}`}>
      {isCcAccount ? (
        <div className="cc-account-scroll">
          <div className="cc-account-content">{accountContent}</div>
        </div>
      ) : (
        accountContent
      )}
    </div>
  );
}